// Permission IDs returned in a user's profile.permissions from the login API
export const PERMISSIONS = {
	JOBS: 1,
	CARS: 2,
	CARPARKS: 3,
	BLACKOUT: 4,
	FUEL_CARD: 5,
	ACCOUNT: 6,
	ISSUES: 8,
	MASTER_DATA: 9,
	SERVICING: 11,
	EV_LOTS: 12,
	MAINTENANCE_REPAIR: 13,
	WSHOP: 14,
} as const;

// Permissions that also grant access to another permission's routes,
// e.g. WSHOP reaches Maintenance & Repair without holding id 13.
const GRANTS: Partial<Record<number, number[]>> = {
	[PERMISSIONS.MAINTENANCE_REPAIR]: [PERMISSIONS.WSHOP],
};

export const hasPermission = (userRole: number[], id: number): boolean =>
	userRole.includes(id) ||
	(GRANTS[id] ?? []).some((granter) => userRole.includes(granter));

// A workshop account: WSHOP is its only permission. Confined to M&R app-wide.
export const isWshopOnly = (userRole: number[]): boolean =>
	userRole.length > 0 &&
	userRole.every((permission) => permission === PERMISSIONS.WSHOP);

// Reaches M&R through WSHOP rather than MAINTENANCE_REPAIR, so gets the
// workshop pages instead of the internal ones (which require id 13).
export const usesWorkshopView = (userRole: number[]): boolean =>
	userRole.includes(PERMISSIONS.WSHOP) &&
	!userRole.includes(PERMISSIONS.MAINTENANCE_REPAIR);

// The single rule for whether a route is visible (Sidebar) and reachable
// (Layout). `permission: null` means no permission is required — but a
// wshop-only user is confined to Maintenance & Repair regardless.
export const canAccessRoute = (
	userRole: number[],
	permission: number | null
): boolean => {
	if (isWshopOnly(userRole)) {
		return permission === PERMISSIONS.MAINTENANCE_REPAIR;
	}
	return permission == null || hasPermission(userRole, permission);
};
